/**
 * <TutorOfferCardSkeleton> — la forme d'une offre pendant qu'elle charge : la date, le titre, une
 * ligne de créneaux, dans la carte.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"

export function TutorOfferCardSkeleton() {
    return (
        <Card p="4">
            <Stack gap="2">
                <Skeleton textSize="text-sm" width={84} />
                <Skeleton textSize="text-lg" width={220} />
                <Skeleton textSize="text-md" width="80%" />
            </Stack>
        </Card>
    )
}
